









































































import { Component, Prop, Vue,Mixins } from 'vue-property-decorator'; 
import store from '@/store';
import * as api from '@/store/api'
import {notFilter} from './filters/filters';
import {Letter} from '@/store/models/Letter/Letter';
import ComponentMixinBase from './components/Cartable/ComponentMixins/ComponentMixinBase';

@Component({
    store,
    filters: {
        notFilter: notFilter,
    }
})
export default class Login extends Mixins(ComponentMixinBase) {
  
  userName = '';
  password = '';
  isUserValid = true;
  version = "";
  created(){
      this.version = store.state.version;
  }

  enter(){
      this.login();
  }
  
  async login(){
      this.isUserValid =  await api.isUserValid(this.userName,this.password);
      if(this.isUserValid){
          this.$store.commit("setIsLoggedIn",true);
          if(this.isMobile()==true){
              this.$router.replace({name: "MainWindowMobile"});
          }else{
              this.$router.replace({name: "MainWindow"});
          }

      }
  }

}

